import type { LeagueSummary } from "@softmax/observatory-client/types";
import { isUnpublishedLeague } from "./league-catalog";

type WatchableLeague<T extends LeagueSummary> = T & {
  readonly game: T["game"] & { readonly coworld_name: string };
};

export function watchableLeagues<T extends LeagueSummary>(
  leagues: readonly T[],
): WatchableLeague<T>[] {
  return leagues
    .filter(
      (league): league is WatchableLeague<T> =>
        !league.hidden &&
        !league.disabled_at &&
        league.game.coworld_name != null,
    )
    .toSorted((a, b) => {
      // Public addresses must not shift when the viewer can also see private leagues.
      const aPrivate = isUnpublishedLeague(a);

      if (aPrivate !== isUnpublishedLeague(b)) return aPrivate ? 1 : -1;

      if (a.is_game_of_week !== b.is_game_of_week) {
        return a.is_game_of_week ? -1 : 1;
      }

      return a.name.localeCompare(b.name);
    });
}
